import { ExcelDownloadBtn } from "components/Buttons/ExcelDownloadBtn";
import { HTTP_METHOD, POST_WITHDRAW_LIST } from "constants/pathConstant";
import { WITHDRAW_XLSX_DOWNLOAD } from "constants/xlsxDownloadConstant";
import { useExcelDownload } from "hooks/excelDownload/useExcelDownload";
import { useToastCustom } from "hooks/useToastCustom";
import { Info, List, Wrapper } from "template/ListTemplate.style";
import { WithdrawInfoDetail } from "./WithdrawInfoDetail";
import swapColumn from "./withdrawColumn.json";
import { useMutationCustom } from "hooks/useMutationCustom";
import PageHandler from "components/PageHandler/PageHandler";
import { xlsxDateFormat } from "components/xlsxDateFormat";
import { useState } from "react";
import { ListDefault } from "components/ListDefault/ListDefault";
import EmptyScreen from "components/EmptyScreen/EmptyScreen";

// 브릿지 -> 출금 :: 출금 신청/처리 목록 (http://localhost:3000/super/bridge/withdraw)
export const WithdrawInfoList = ({
  setPage,
  setSize,
  withdrawList,
  searchData,
  setWithdrawList,
  isSearch,
}) => {
  const excelDownload = useExcelDownload();
  const toast = useToastCustom();

  const [isOngoing, setIsOngoing] = useState(false);

  const { mutate } = useMutationCustom(POST_WITHDRAW_LIST, HTTP_METHOD.POST);

  // Excel 다운로드
  const handleExcelDownload = () => {
    if (!isSearch || !withdrawList.list[0]?.cnt) {
      toast("다운로드할 데이터가 없습니다", "error");
      return;
    }

    const researchCond = {
      ...searchData,
      pageSize: withdrawList.list[0]?.cnt,
      currentPage: 1,
    };

    mutate(researchCond, {
      onSuccess: (response) => {
        const updatedResponse = xlsxDateFormat(response.list);

        const excelData = {
          data: updatedResponse,
          headers: WITHDRAW_XLSX_DOWNLOAD.header,
          fileName: WITHDRAW_XLSX_DOWNLOAD.filename,
        };

        excelDownload(excelData);
      },

      onError: () => {
        toast("데이터 전체 조회 실패", "error");
      },
    });
  };

  return (
    <Wrapper>
      <List.TitleContainer>
        <List.TextContainer>
          <List.Text>인출 내역</List.Text>
        </List.TextContainer>

        <List.BtnContainer>
          {/* 페이지 핸들러 */}
          <PageHandler setPage={setPage} setPageSize={setSize} />
          {/* 엑셀 다운로드 버튼 */}
          <ExcelDownloadBtn onClick={handleExcelDownload} />
        </List.BtnContainer>
      </List.TitleContainer>

      <List.Container>
        {!isSearch && <ListDefault text={"인출 내역을"} />}
        {isSearch && !withdrawList.list.length && <EmptyScreen />}
        {isSearch && !!withdrawList.list.length && (
          <>
            <List.Content>
              {swapColumn.data.map((v, idx) => (
                <List.Row $ratio={v.ratio} key={idx}>
                  {v.title}
                </List.Row>
              ))}
            </List.Content>
            <Info.Wrapper>
              {withdrawList.list.map((v, idx) => (
                <WithdrawInfoDetail
                  data={v}
                  key={idx}
                  setWithdrawList={setWithdrawList}
                  searchData={searchData}
                  setIsOngoing={setIsOngoing}
                  isOngoing={isOngoing}
                />
              ))}
            </Info.Wrapper>
          </>
        )}
      </List.Container>
    </Wrapper>
  );
};
